module.exports = __webpack_public_path__ + "img/ai.743fbf50.svg";